<script setup lang="ts">
import { ref, computed } from 'vue'
import { baseUrl } from '@/core'

// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// State -----------------------------------------
const { lang } = props

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <template v-for="n in 10">
    <img :class="['menu-caption', `menu-caption-${n}`, `lang-${lang}`]" :src="baseUrl(`/images/home/${lang}/menu-caption-${n}.png`)" />
  </template>
</template>

<style scoped>
/* ------------------------ */
.menu-caption {
  position: absolute;
}
/* ------------------------ */
/* prettier-ignore */
.menu-caption-1 { left: 827px; top: 430px; }
/* prettier-ignore */
.menu-caption-2 { left: 827px; top: 570px; }
/* prettier-ignore */
.menu-caption-3 { left: 827px; top: 705px; }
/* prettier-ignore */
.menu-caption-4 { left: 827px; top: 850px; }
/* prettier-ignore */
.menu-caption-5 { left: 1368px; top: 430px; }
/* prettier-ignore */
.menu-caption-6 { left: 1368px; top: 510px; }
/* prettier-ignore */
.menu-caption-7 { left: 1368px; top: 595px; }
/* prettier-ignore */
.menu-caption-8 { left: 1368px; top: 684px; }
/* prettier-ignore */
.menu-caption-9 { left: 1368px; top: 765px; }
/* prettier-ignore */
.menu-caption-10 { left: 1368px; top: 850px; }
/* ------------------------ */
/* prettier-ignore */
.menu-caption-1.lang-en { left: 827px; top: 430px; }
/* prettier-ignore */
.menu-caption-2.lang-en { left: 827px; top: 553px; }
/* prettier-ignore */
.menu-caption-3.lang-en { left: 827px; top: 674px; }
/* prettier-ignore */
.menu-caption-4.lang-en { left: 827px; top: 794px; }
/* prettier-ignore */
.menu-caption-5.lang-en { left: 827px; top: 884px; }
/* prettier-ignore */
.menu-caption-6.lang-en { left: 1368px; top: 430px; }
/* prettier-ignore */
.menu-caption-7.lang-en { left: 1368px; top: 553px; }
/* prettier-ignore */
.menu-caption-8.lang-en { left: 1368px; top: 636px; }
/* prettier-ignore */
.menu-caption-9.lang-en { left: 1368px; top: 760px; }
/* prettier-ignore */
.menu-caption-10.lang-en { left: 1368px; top: 884px; }
/* ------------------------ */
</style>
